import React from 'react';

/**
 * Couple testimonials.
 *
 * Ported verbatim from toastably-web/partials/section-testimonials.html. Identical on every
 * landing page, which is why it is a component rather than per-page data.
 */
const Testimonials = () => (
  <section className="section-testimonials" aria-labelledby="testimonials-title">
    <div className="container">
      <h2 id="testimonials-title" className="visually-hidden">
        Was Paare über Toastably sagen
      </h2>
      <div className="testimonial-grid">
        <figure className="testimonial">
          <blockquote className="testimonial-text" cite="https://toastably.com/">
            <p>
              Toastably hat unsere Hochzeitsplanung komplett verändert. In einer Stunde haben wir
              mehr passende Anbieter:innen gefunden und verglichen als in zwei Wochen E-Mail-Chaos
              zuvor.
            </p>
          </blockquote>
          <figcaption className="testimonial-attr">
            <cite className="testimonial-author">Carina und Philippe</cite>
            <span className="testimonial-location">Zürich, Schweiz</span>
          </figcaption>
        </figure>
        <figure className="testimonial">
          <blockquote className="testimonial-text" cite="https://toastably.com/">
            <p>
              Toastably ist einfach eine geniale Idee. Endlich eine Plattform, die Paare und
              Anbieter easy zusammenbringt, ohne unnötigen Schnickschnack. Hier sind viele
              spezielle, quirlige und coole Dienstleister dabei. Genau deshalb bin ich auch hier.
            </p>
          </blockquote>
          <figcaption className="testimonial-attr">
            <cite className="testimonial-author">Mama Luna</cite>
            <span className="testimonial-location">Inhaberin Aperolino</span>
          </figcaption>
        </figure>
        <figure className="testimonial">
          <blockquote className="testimonial-text" cite="https://toastably.com/">
            <p>
              Vom Fotografen bis zur Band – alles an einem Ort gebucht. Die fixe Bestätigung mit
              sicherer Bezahlung gab uns die Sicherheit, die wir bei der Planung brauchten.
            </p>
          </blockquote>
          <figcaption className="testimonial-attr">
            <cite className="testimonial-author">Anna und Tobias</cite>
            <span className="testimonial-location">Bülach, Schweiz</span>
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
);

export default Testimonials;
